import { alignItems, keyframes } from '@mui/system';

// Shared look for the registration dialog.
export const COLORS = {
  surface: 'rgba(42, 42, 42, 1)',
  card: 'rgba(255,255,255,0.04)',
  border: 'rgba(255,255,255,0.15)',
  borderStrong: 'rgba(255,255,255,0.35)',
  text: '#f0f0f0',
  muted: 'rgba(255,255,255,0.65)',
  accent: '#ffffff',
  onAccent: '#121212',
  error: '#ff8a8a',
  scrollTrack: 'rgba(42, 42, 42, 1)', // same as surface
  scrollThumb: 'rgba(92, 92, 92, 1)', // lighter shade of surface
  scrollThumbHover: 'rgba(120, 120, 120, 1)',
};

const fieldIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
`;

// Field wrapper: two per row on desktop. Animation runs on mount, so conditional fields ease in.
export const fieldSx = (field, mobile) => ({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  flex: field.alternateLabel || mobile ? '0 0 100%' : '0 0 calc(50% - 16px)',
  minWidth: 0,
  animation: `${fieldIn} 0.25s ease`,
});

// Dialog paper shared by the booking dialog, terms, contact and confirmation pages.
export const paperSx = ({ fullScreen, maxWidth = 900, fixedHeight = false }) => ({
  backgroundColor: COLORS.surface,
  backgroundImage: 'none',
  color: COLORS.text,
  borderRadius: fullScreen ? 0 : 2,
  maxWidth,
  height: fullScreen ? '100%' : fixedHeight ? 'min(92vh, 960px)' : 'auto',
  border: `1px solid ${COLORS.border}`,
  boxShadow: '0 8px 32px rgba(0,0,0,0.45)',
});

// Dark scrollbar for the dialog's scrolling area (track = surface, thumb = lighter shade).
export const scrollSx = {
  '&::-webkit-scrollbar': { width: 10, backgroundColor: COLORS.scrollTrack },
  '&::-webkit-scrollbar-track': { backgroundColor: COLORS.scrollTrack },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: COLORS.scrollThumb,
    borderRadius: 5,
    border: `2px solid ${COLORS.scrollTrack}`,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: COLORS.scrollThumbHover,
  },
  // Firefox
  '@supports not selector(::-webkit-scrollbar)': {
    scrollbarColor: `${COLORS.scrollThumb} ${COLORS.scrollTrack}`,
    scrollbarWidth: 'thin',
  },
};
